import '../reset.css';
import '../style.css';
import './_common/my_sentry.js';
import {initIframeResize} from './_inIFrame.js';

initIframeResize();
